import {AvailabilityRequest} from './../model/availability/availability-request-model';
import {ServiceAddressRequest} from './../model/availability/service-address-request';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from './../../environments/environment';
import {ServiceAddress} from './../model/availability/service-address';

@Injectable({
    providedIn: 'root'
})
export class AvailabilityService {

    private baseUrl: string;
    constructor(private http: HttpClient) {
        this.baseUrl = environment.ppApiUrl;
    }
    public saveAvailability(availabilityRequest: AvailabilityRequest): Observable<any> {
        console.log("saveAvailability:: Saving data..");
        console.log(availabilityRequest);
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<string>(this.baseUrl.concat("/availabilities/save"), availabilityRequest, { headers: headers });
    }

    public getProviderServiceAddress(providerId: string): Observable<any> {
        console.log("Get service Address..");
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        return this.http.get<any>(this.baseUrl.concat("/availabilities/provider/")
            .concat(providerId), { headers: headers });
    }

    public updateServiceAddressData(serviceAddressRequest: ServiceAddress): Observable<any> {
        console.log("Updating provider data..");
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        return this.http.post<ServiceAddress[]>(this.baseUrl.concat("/availabilities/provider/update/address"), serviceAddressRequest, { headers: headers });
    }

    public getStatesList() {
        console.log("Statessssssssssssss ");
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        return this.http.get<any>(this.baseUrl.concat("/states/"), { headers: headers });
    }

    public saveServiceAddressData(serviceAddressRequest: ServiceAddressRequest): Observable<any> {
        console.log("Saving provider data..");
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        return this.http.post<ServiceAddress>(this.baseUrl.concat("/availabilities/provider/save/address"), serviceAddressRequest, { headers: headers });

    }

    public getDefaultSlotsDetailByProviderId(providerId: string): Observable<any> {
        console.log("Get Available Default Slots  details..");
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        return this.http.get<any>(this.baseUrl.concat("/availabilities/").concat(providerId), { headers: headers });
    }

    public getSlotsDetailByProviderId(providerId: string): Observable<any> {
        console.log("Get Available Slots  details..");
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        return this.http.get<any>(this.baseUrl.concat("/current/schedules/").concat(providerId), { headers: headers });
    }

  public loadClients(userId: string): Observable<any> {
    const params = new HttpParams()
      .append('providerId', userId)
      .append('visitTypeId', '2');
    return this.http.get<any>(this.baseUrl.concat('/clients'), { params });
  }

    public loadProjectsByClientId(clientId: number): Observable<any> {
        console.log('Clients List Details');
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<any>(this.baseUrl.concat('/projects/client/').concat(clientId.toString()), { headers: headers });
    }

    public loadProjects(userId: string, clientId: number): Observable<any> {
        console.log('userId: '+userId +', clientId:'+ clientId);
        let payload = {
            "clientId": clientId,
            "nursePractitionerId": userId,
            "visitTypeId": "2"
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<any>(this.baseUrl.concat('/projects/'), payload, { headers: headers })
    }

}
